<template>
    <div
        @click="openMenu($event, 'leftClick')"
        @contextmenu="openMenu($event, 'rightClick')"
        class="menu"
    >
        <transition name="fade">
            <div
                :style="{ top: top, left: left }"
                @blur="isMenuOpened = false"
                class="menu-body"
                ref="menu"
                tabindex="-1"
                v-if="isMenuOpened"
            >
                <div
                    :key="index"
                    @click="emitAction(row.event)"
                    class="menu-row"
                    v-for="(row, index) in menuContent"
                >
                    <img
                        :src="require(`@/${row.specialIcon}`)"
                        class="menu-icon"
                        v-if="row.specialIcon"
                    />
                    <img
                        :src="row.image"
                        class="menu-icon -avatar"
                        v-if="row.image"
                    />
                    <i class="material-icons" v-if="row.materialIcon">{{
                        row.materialIcon
                    }}</i>
                    <section>{{ $t(row.display) }}</section>
                </div>
            </div>
        </transition>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        menuContent: Array,
        rightClickEvents: Boolean,
        leftClickEvents: {
            type: Boolean,
            default: true
        },
        disabled: Boolean,
        block: Boolean
    },
    data() {
        return {
            isMenuOpened: false,
            top: '0px',
            left: '0px'
        }
    },
    methods: {
        emitAction(action) {
            this.$emit('action', action)
            this.$nextTick(() => {
                this.isMenuOpened = false
            })
        },
        setMenu(top, left) {
            if (!this.$refs.menu) {
                return
            }
            let largestHeight =
                window.innerHeight - this.$refs.menu.offsetHeight - 25
            let largestWidth =
                window.innerWidth - this.$refs.menu.offsetWidth - 25

            if (top > largestHeight) {
                top = largestHeight
            }
            if (left > largestWidth) {
                left = largestWidth
            }
            this.top = `${top}px`
            this.left = `${left}px`

            this.$nextTick(() => {
                this.$refs.menu.focus()
            })
        },
        openMenu($event, type) {
            this.$emit('click')
            if (this.disabled) {
                return
            }
            if (this.isMenuOpened == true) {
                return
            }
            if (!this.rightClickEvents && type == 'rightClick') {
                return
            }
            if (!this.leftClickEvents && type == 'leftClick') {
                return
            }

            if (
                this.menuContent &&
                this.menuContent.length == 1 &&
                !this.block
            ) {
                this.$emit('action', this.menuContent[0].event)
            } else {
                this.isMenuOpened = true
                this.$nextTick(() => {
                    this.setMenu($event.clientY, $event.clientX)
                })
                $event.preventDefault()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.menu-area {
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: $toast;
}
.menu-body {
    position: fixed;
    background: $background;
    box-shadow: $minimal-shadow;
    border-radius: $minimal-radius;
    z-index: $toast;
    outline: none;
    color: $input;
    max-height: 30%;
    overflow-y: auto;
    pointer-events: all !important;
    font-size: 1.1rem !important;
}
.menu-row {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.5rem;
    padding-right: 2rem;
    transition: $ease;
    cursor: pointer;
    font-family: $input-family;
    position: relative;
    user-select: none;

    &:hover {
        background: $hover-background;
    }
}
.menu-row span {
    background: $background;
    position: fixed;
    opacity: 0;
    pointer-events: none;
    transition: 0.3s ease all;
    box-shadow: $object-shadow;
    padding: 0.2rem 0.4rem;
    max-width: 20rem;
    border-radius: 0.5rem;
    margin-top: -3rem;
    margin-left: 3rem;
}
.menu-row:hover span {
    opacity: 1;
}
.menu-row i {
    font-size: 1.3rem;
}
.menu-icon {
    height: 1rem;
    margin-right: 0.5rem;

    &.-avatar {
        border-radius: 100%;
        border: #fff solid 1px;
    }
}
.material-icons {
    margin-right: 0.5rem;
    color: $action-accent;
}
</style>
